import fetch from 'auth/FetchInterceptor'

const InstructionService = {}

InstructionService.getInstructionsListDynamic = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Instruction/GetInstructionsDynamic?index=${params.index}&size=10`,
        method: 'post',
        data: params.finalQuery,
    })
}

InstructionService.addInstruction = function (data) {
    return fetch({
        url: process.env.REACT_APP_API_URL + 'portal/Instruction',
        method: 'post',
        data: data,
    })
}

InstructionService.deleteInstruction = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Instruction/${params}`,
        method: 'delete',
        params,
    })
}

InstructionService.getInstruction = function (params) {
    return fetch({
        url: process.env.REACT_APP_API_URL + `portal/Instruction/${params}`,
        method: 'get',
        params,
    })
}

export default InstructionService
